<template>
  <div class="modal-wrapper">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close" @click="emitCloseModal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Criar período de rematrícula
          </h4>
        </div>
        <div class="modal-body">
          <div>
            <h4><strong>Observações:</strong></h4>
            <ul>
              <li>
                O ano deve ser igual ao atual ou ao próximo.
              </li>
              <li>
                Os alunos só entram efetivamento no processo de rematrícula após a importação da planilha de alunos.
              </li>
            </ul>
          </div>
          <div v-if="inputError" class="alert alert-danger">
            {{ inputError }}
          </div>
          <div>
            <label>Período</label>
            <input
              type="text"
              class="form-control"
              v-mask="'####.##'"
              v-model="period"
              placeholder="2020.1"
              @keypress="clearInputError"
              @keyup.enter="createReenrollmentContract"
            >
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="createReenrollmentContract">
            Criar período
          </button>
          <button class="btn btn-default" @click="emitCloseModal">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ReenrollmentContractsService from 'services/ReenrollmentContractsService';

export default {
  data() {
    return {
      period: null,
      inputError: null,
    };
  },
  computed: {
    ...mapState([
      'institution',
    ]),
  },
  methods: {
    clearInputError() {
      this.inputError = null;
    },
    emitCloseModal() {
      this.$emit('close');
    },
    createReenrollmentContract() {
      if (!this.validateInput()) return;

      this.$loader.show();
      this.createReenrollmentContractService();
    },
    createReenrollmentContractService() {
      ReenrollmentContractsService.createReenrollmentContract(this.institution.id, this.period)
        .then(() => {
          this.$alert.notifySuccess('Período de rematrícula criado com sucesso!');
        })
        .catch(() => {
          this.$alert.notifyAlert('Erro ao criar período de rematrícula.');
        })
        .finally(() => {
          this.emitCloseModal();
          this.$loader.hide();
        });
    },
    validateInput() {
      if (RegExp('\\d{4}\\.\\d{1,2}', 'g').test(this.period)) {
        this.inputError = null;
        return true;
      }

      this.inputError = 'Formato do período inválido.';
      return false;
    },
  },
};
</script>
